import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { appInsights } from "../../config/appInsights";
import MFBTransactionSettings from "./MFB/MFBTransactionSettings";

const TransactionSettings = () => {
  const { isAuthenticated } = useSelector(
    (state: RootState) => state?.authReducer,
  );

  const history = useHistory();

  useEffect(() => {
    if (!isAuthenticated) {
      history.push("/login");
    }

    appInsights.trackPageView({
      name: "TransactionSettings - (TransactionSettings.tsx)",
      isLoggedIn: true,
    });
  }, []);

  return (
    <div className="Settings datatable-wrapper">
      <div className="table-view">
        <div className="block-header">
          <h3 className="page-title mb-4">MFB Transaction Settings</h3>

          <MFBTransactionSettings />
        </div>
      </div>
    </div>
  );
};

export default TransactionSettings;
